import React from "react";
import PropTypes from "prop-types";

const Checkbox = (props) => {

  const { input, meta, htmlAttributes, styles } = props;
  const { name } = input;
  let inputStyles = ["form-control"];
  let parentDivStyles = ["form-group checkbox"];
  const ariaDescription = `Barclaycard CL Apply Application-sr-description`;

  if (styles) {
    inputStyles = inputStyles.concat(styles.input);
    parentDivStyles = parentDivStyles.concat(styles.formGroup);
  }

  let ariaDescriptionExists = false;
  let errorMarkup = null;

  if ((meta.error && meta.dirty && !meta.active) || (meta.error && meta.submitFailed && !meta.active)) {
    inputStyles.push("is-invalid");
    parentDivStyles.push("is-invalid-field");
    ariaDescriptionExists = true;
    errorMarkup = (<div id={ariaDescription} className="invalid-feedback">{meta.error}</div>);
  }

  return (
    <div className={parentDivStyles.join(' ')}>
      <input
        id={name}
        type="checkbox"
        className={inputStyles.join(' ')}
        aria-describedby={ariaDescriptionExists ? ariaDescription : undefined}
        aria-invalid={ariaDescriptionExists}
        required={props.required}
        {...input}
        {...htmlAttributes}
      />
      <label
        htmlFor={name}
      >
        {props.label}
      </label>
      {errorMarkup}
    </div>);
};

Checkbox.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string.isRequired
  }),
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    active: PropTypes.bool,
    error: PropTypes.string
  }),
  required: PropTypes.bool
};

export default Checkbox;
